module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if(locals.carrier_types.length == 0) { 
    ; __append(" <div class=\"no_results\">No carrier types match your filter text.</div> ")
    ;  } else { 
    ; __append(" <div class=\"carrier-type-list panel\"> ")
    ;  _.each(locals.carrier_types, function(model, index) { 
    ; __append(" <div id=\"ct_")
    ; __append(escapeFn( model.get('type') ))
    ; __append("\" class=\"carrier_type\"></div> ")
    ;  }); 
    ; __append(" <div class=\"new-carrier-request\"> <h5 class=\"bold\">Want an additional carrier?</h5> <div>Email <a href=\"mailto:support@easypost.com?subject=New%20Carrier%20Request\" target=\"_blank\">support@easypost.com</a>, we add new carriers all the time.</div> </div> </div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/carrier_type_list.ejs
// module id = 878
// module chunks = 1